import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Registration.css";

// Components
import { Grid, MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {
  setRoccupation,
  setRusage,
} from "../../features/registration/registrationSlice";
function Registrationpg2() {
  const [code, setCode] = React.useState("");
  const [occupation, setOccupation] = React.useState("");
  const [usage, setUsage] = React.useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const occupationArray = [
    "College student",
    "Master's student",
    "PhD student",
    "Professor",
    "Data Scientist",
    "Others",
  ];
  const usageArray = [
    "For a school related activity",
    "For my thesis/dissertation",
    "For my research",
    "For a project",
    "For my company",
  ];
  const handleChangePage = () => {
    dispatch(setRoccupation(occupation));
    dispatch(setRusage(usage));
    navigate("/registrationPg3");
  };
  const handleSkipPage = () => {
    navigate("/registrationPg3");
  };
  const value = useSelector((state) => state.registration);
  // console.log(value);
  return (
    <>
      <Grid container spacing={2} direction="row" justifyContent="center">
        <Grid item xs="auto" sx={{ marginLeft: "5rem" }}>
          <Box className="card card--left">
            <Box className="card">
              <Box>
                <h1 className="card__title">Welcome to Tuos</h1>
              </Box>
              <Box>
                <Box mt="1.5em" />
                <p className="card__text">
                  In order to proceed with the platform, we would to get to know
                  you better.
                </p>
                <Box mt="1.5em" />
                <p className="card__text">This will only take 1 - 2mins.</p>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs="auto">
          <Box className="card card--right">
            <Box
              className="card"
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
            >
              <Grid container spacing={2} mt={2}>
                <h2 className="textfield__text">
                  We'd like to get know you better
                </h2>
                <Grid direction="column" md={6}>
                  <h3 className="textfield__text">You are currently a...</h3>
                  <TextField
                    required
                    select
                    name="occupation"
                    onChange={(e) => setOccupation(e.target.value)}
                    // disable autocomplete
                    inputProps={{
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                      style: {
                        fontSize: 15,
                        paddingTop: 10,
                      },
                    }}
                    className="textfield"
                    label="Occupation"
                  >
                    {occupationArray.map((val) => {
                      return <MenuItem value={val}>{val}</MenuItem>;
                    })}
                  </TextField>
                </Grid>
                <Grid md={6} direction="column">
                  <h4 className="textfield__text1">
                    and you will primarily be using Tuos for...
                  </h4>

                  <TextField
                    required
                    select
                    name="usage"
                    onChange={(e) => setUsage(e.target.value)}
                    // disable autocomplete
                    inputProps={{
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                      style: {
                        fontSize: 15,
                        paddingTop: 10,
                      },
                    }}
                    className="textfield"
                    label="Usage"
                  >
                    {usageArray.map((val) => {
                      return <MenuItem value={val}>{val}</MenuItem>;
                    })}
                  </TextField>
                </Grid>
              </Grid>
              <Box pb="30em" />
            </Box>
          </Box>
          <Grid container spacing={2} mt={2} ml="2rem">
            <Grid
              ml="19.2em"
              justify="space-between" // Add it here :)
              row
              spacing={24}
            >
              <Button
                variant="text"
                className="skip-button "
                onClick={handleSkipPage}
              >
                Skip
              </Button>
            </Grid>
            <Grid row md={1}>
              <Button
                variant="contained"
                className="success__button1"
                onClick={handleChangePage}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Registrationpg2;
